export default "/assets/images/chart-03.565026da6b4bcd3c.svg";